import React from 'react';

import { Routes, Route } from "react-router-dom";
import { AuthContextProvider } from './context/AuthContext';
import './App.css';
import LoginPage from './pages/LoginPage';
import TransactionsPage from './pages/TransactionsPage';
import TransactionsSentPage from './pages/TransactionsSentPage';
import TransactionsCheckedInPage from './pages/TransactionsCheckedInPage'; // #POW-20
import AllTransactionsPage from './pages/AllTransactionsPage'; // #POW-80
import ExportArchivePage from './pages/ExportArchivePage'; // #POW-100

const App = () => {
  return (
    <AuthContextProvider> {/* @see index.tsx which wraps AuthContext with BrowserRouter */}
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<TransactionsPage />} /> {/* SHOP + LOGISTIC */}
          <Route path="/transactions-sent" element={<TransactionsSentPage />} /> {/* SHOP */}
          <Route path="/transactions-checked-in" element={<TransactionsCheckedInPage />} /> {/* #POW-20 - LOGISTIC */}
          <Route path="/all-transactions" element={<AllTransactionsPage />} /> {/* #POW-80 - LOGISTIC */}
          <Route path="/exports" element={<ExportArchivePage />} /> {/* #POW-100 - LOGISTIC */}
        </Routes>
    </AuthContextProvider>
  );
}

export default App;
